<template>
  <div class="pa-4" style="position: relative; height: 100%;">
    <debt-wizard
        ref="debtWizardDialog"
        :household="household"
        @on-save="updateSavedDebt"
    />
    <v-row>
      <v-col
        cols="12"
      >
        <v-stepper
          v-model="step"
          vertical
          class="elevation-0"
        >
          <v-stepper-step
            :complete="step > 1"
            step="1"
          >
            <span>
              <span :class="{'caption grey--text':step > 1}">Spouse</span>
              <div v-if="step > 1"><b>{{ spouse ? spouse.full_name : 'No Spouse' }}</b></div>
            </span>
          </v-stepper-step>
          <v-stepper-content step="1">
            <div class="title text-center">Enter {{ namePlural }} spouse information</div>
            <v-container fluid>
              <v-row class="justify-center align-center">
                <v-col
                  cols="4"
                >
                  <div v-if="!this.spouse_full_name">

                    <user-search-field
                        label="Add Spouse"
                        clearable
                        :agent-id="(household.user.agent_id || null)"
                        :user="user"
                        :householdId="household.id"
                        @new-spouse_id="newSpouseId"
                    />
                  </div>
                  <div class="text-center">
                    {{this.spouse_full_name}}
                  </div>

                </v-col>
              </v-row>
              <v-row class="my-8 justify-center">
                <v-btn small color="primary" class="ml-2" :disabled="!canContinue" @click="nextStep">Continue</v-btn>
              </v-row>
            </v-container>
          </v-stepper-content>


          <v-stepper-step
            :complete="step > 2"
            step="2"
          >
            <span>
              <span :class="{'caption grey--text':step > 1}">Desired Outcomes</span>
              <div v-if="step > 2"><b></b></div>
            </span>
          </v-stepper-step>
          <div v-if="step == 2">
            <iframe :src="video_object[this.step]" width="100%" height="290" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
          </div>
          <v-stepper-content step="2">
            <div class="title text-center">Enter {{ namePlural }} desired outcomes</div>
            <v-container fluid>
              <v-row class="justify-center align-center">
                <v-col cols="12" class="py-0">
                  <v-row
                    v-for="(desout,desind) in desiredOutcomes"
                    :key="'di-' + desind"
                    class="justify-center"
                  >
                    <v-col cols="6" class="py-2">
                      <v-text-field
                        v-model="desiredOutcomes[desind]"
                        outlined
                        dense
                        hide-details
                        placeholder="Enter Outcome Here..."
                        :append-outer-icon="(desiredOutcomes.length > 1 ? 'mdi-close' : null)"
                        @click:append-outer="removeDesiredOutcome(desind)"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="text-center mt-4">
                  <v-btn small color="primary" @click="addDesiredOutcomes" outlined :disabled="desiredOutcomes.length >= 5"><v-icon small>mdi-plus</v-icon> Add Desired Outcome</v-btn>
                </v-col>
              </v-row>
              <v-row class="my-8 justify-center">
                <v-btn small text color="primary" @click="goBack">Back</v-btn>
                <v-btn small color="primary" class="ml-2" :disabled="!canContinue" @click="nextStep">Continue</v-btn>
              </v-row>
            </v-container>
          </v-stepper-content>


          <v-stepper-step
            :complete="step > 3"
            step="3"
          >
            <span>
              <span :class="{'caption grey--text':step > 3}">Main Income</span>
              <div v-if="step > 3"><b>{{ mainIncomeSum | currency }}</b></div>
            </span>
          </v-stepper-step>
          <div v-if="step == 3">
            <iframe :src="video_object[this.step]" width="100%" height="290" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
          </div>
          <v-stepper-content step="3">
            <div class="title text-center">Please add all main income information</div>
            <v-container fluid>
              <v-row class="justify-center">
                <v-col cols="12" class="py-0">
                  <v-row
                    v-for="(income,incomeIndex) in mainIncomes"
                    :key="'mainincome-' + incomeIndex"
                    class="justify-center"
                  >
                    <v-col cols="3" class="py-1">
                      <v-text-field
                        v-model="income.name"
                        outlined
                        dense
                        hide-details
                        label="Name"
                      />
                    </v-col>
                    <v-col cols="3" class="py-1">
                      <v-text-field
                        v-model="income.amount"
                        outlined
                        dense
                        hide-details
                        label="Monthly Amount ($)"
                        :append-outer-icon="(mainIncomes.length > 1 ? 'mdi-close' : null)"
                        @click:append-outer="removeMainIncome(incomeIndex)"
                      />
                    </v-col>
                    <v-col cols="3" class="py-1">
                      <v-text-field
                        v-model="income.increase"
                        outlined
                        dense
                        hide-details
                        label="Annual Increase ($)"
                        :append-outer-icon="(mainIncomes.length > 1 ? 'mdi-close' : null)"
                        @click:append-outer="removeMainIncome(incomeIndex)"
                      />
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" class="text-center mt-4">
                  <v-btn small color="primary" @click="addMainIncome" outlined><v-icon small>mdi-plus</v-icon> Add Main Income</v-btn>
                </v-col>
              </v-row>
              <v-row class="my-8 justify-center">
                <v-btn small text color="primary" @click="goBack">Back</v-btn>
                <v-btn small color="primary" class="ml-2" :disabled="!canContinue" @click="nextStep">Continue</v-btn>
              </v-row>
            </v-container>
          </v-stepper-content>


          <v-stepper-step
            :complete="step > 4"
            step="4"
          >
            <span>
              <span :class="{'caption grey--text':step > 4}">Passive Income</span>
              <div v-if="step > 4"><b>{{ incomeSum | currency }}</b></div>
            </span>
          </v-stepper-step>
          <div v-if="step == 4">
            <iframe :src="video_object[this.step]" width="100%" height="290" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
          </div>
          <v-stepper-content step="4">
            <div class="title text-center">Please add all passive income information</div>
            <v-container fluid>
              <v-row class="justify-center">
                <v-col cols="12" class="py-0">
                  <v-row
                    v-for="(income,incomeIndex) in incomes"
                    :key="'income-' + incomeIndex"
                  >
                    <v-col cols="3" class="py-1">
                      <v-text-field
                        v-model="income.name"
                        outlined
                        dense
                        hide-details
                        label="Name"
                      />
                    </v-col>
                    <v-col cols="3" class="py-1">
                      <v-text-field
                        v-model="income.amount"
                        outlined
                        dense
                        hide-details
                        label="Monthly Amount ($)"
                        :append-outer-icon="(incomes.length > 1 ? 'mdi-close' : null)"
                        @click:append-outer="removeIncome(incomeIndex)"
                      />
                    </v-col>
                    <v-col cols="3" class="py-1">
                      <v-text-field
                        v-model="income.increase"
                        outlined
                        dense
                        hide-details
                        label="Annual Increase ($)"
                      />
                    </v-col>
                    <v-col cols="3" class="py-1">
                      <v-text-field
                        v-model="income.until"
                        outlined
                        dense
                        hide-details
                        label="Continues Until"
                        :append-outer-icon="(incomes.length > 1 ? 'mdi-close' : null)"
                        @click:append-outer="removeIncome(incomeIndex)"
                      />
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" class="text-center mt-4">
                  <v-btn small color="primary" @click="addIncome" outlined><v-icon small>mdi-plus</v-icon> Add Income</v-btn>
                </v-col>
              </v-row>
              <v-row class="my-8 justify-center">
                <v-btn small text color="primary" @click="goBack">Back</v-btn>
                <v-btn small color="primary" class="ml-2" :disabled="!canContinue" @click="nextStep">Continue</v-btn>
              </v-row>
            </v-container>
          </v-stepper-content>

          <v-stepper-step
            :complete="step > 5"
            step="5"
          >
            <span>
              <span :class="{'caption grey--text':step > 5}">Wealth Transfers</span>
              <div v-if="step > 5"><b>{{ totalDebts | currency }}</b></div>
            </span>
          </v-stepper-step>
          <div v-if="step == 5">
            <iframe :src="video_object[this.step]" width="100%" height="290" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
          </div>
          <v-stepper-content step="5">
            <div class="title text-center">Add all wealth transfer information</div>
            <v-container fluid>
              <v-row class="justify-center">
                <v-col
                  v-for="debt in debtsSorted"
                  :key="'debt' + debt.id"
                  cols="12"
                  sm="6"
                  md="4"
                  lg="3"
                >
                  <debt-card
                    :debt="debt"
                    @on-delete="$emit('on-debt-deleted',debt)"
                  />
                </v-col>
              </v-row>
              <v-row class="justify-center">
                <v-col cols="3">
                  <debt-card
                    :debt="{}"
                    @on-click="$refs.debtWizardDialog.open()"
                    dense
                  />
                </v-col>
              </v-row>
              <v-row class="my-8 justify-center">
                <v-btn small text color="primary" @click="goBack">Back</v-btn>
                <v-btn small color="primary" class="ml-2" :disabled="!canContinue" @click="nextStep">Continue</v-btn>
              </v-row>
            </v-container>
          </v-stepper-content>


          <v-stepper-step
            :complete="step > 6"
            step="6"
          >
            <span>
              <span :class="{'caption grey--text':step > 6}">Current Life Insurance</span>
              <div v-if="step > 6"><b>{{insurances.filter(a => a.monthly_premium > 0).length + (insurances.filter(a => a.monthly_premium > 0).length == 1 ? ' Policy' : ' Policies')}}</b></div>
            </span>
          </v-stepper-step>
          <div v-if="step == 6">
            <iframe :src="video_object[this.step]" width="100%" height="290" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
          </div>
          <v-stepper-content step="6">
            <div class="title text-center">Include all current life insurance policies</div>
            <v-container fluid>
              <v-row>
                <v-col
                  cols="12"
                  v-for="(iAccount, iIndex) in insurances"
                  :key="'insurance-debt-' + iIndex"
                  class="py-2"
                >
                  <v-row class="justify-center">
                    <v-col cols="2" class="py-0">
                      <v-select
                        v-model="iAccount.owner"
                        :items="ownerSelections"
                        hide-details
                        outlined
                        dense
                        placeholder="Choose..."
                        label="Owner"
                        clearable
                      />
                    </v-col>
                    <v-col class="py-0" style="width: 240px; max-width: 240px; min-width: 240px;">
                      <v-select
                        v-model="iAccount.type"
                        :items="[{text: 'Term Insurance', value: 'term'},{text: 'Cash Insurance', value: 'cash'}]"
                        hide-details
                        outlined
                        dense
                        label="What Type"
                        placeholder="Choose"
                        clearable
                      />
                    </v-col>
                    <v-col v-if="iAccount.type && iAccount.owner" class="py-0">
                      <v-text-field
                        v-model="iAccount.company"
                        hide-details
                        outlined
                        dense
                        clearable
                        label="Company"
                      />
                    </v-col>
                    <v-col v-if="iAccount.type && iAccount.owner" class="py-0">
                      <v-text-field
                        v-model="iAccount.death_benefit"
                        hide-details
                        outlined
                        dense
                        clearable
                        label="Death Benefit"
                      />
                    </v-col>
                    <v-col  v-if="iAccount.type && iAccount.owner" class="py-0">
                      <v-text-field
                        v-model="iAccount.monthly_premium"
                        hide-details
                        outlined
                        dense
                        clearable
                        label="Monthly Premium"
                      />
                    </v-col>

                    <v-col v-if="iAccount.type == 'term' && iAccount.owner" class="py-0">
                      <v-text-field
                        v-model="iAccount.term_left"
                        hide-details
                        outlined
                        dense
                        clearable
                        label="Term Left"
                      />
                    </v-col>
                    <v-col v-if="iAccount.type == 'cash' && iAccount.owner" class="py-0">
                      <v-text-field
                        v-model="iAccount.cash_value"
                        hide-details
                        outlined
                        dense
                        clearable
                        label="Cash Value"
                      />
                    </v-col>
                    <v-spacer v-if="insurances.length > 1 && (!iAccount.owner || !iAccount.type)" />
                    <v-col class="py-0 flex-grow-0 flex-shrink-1" v-if="insurances.length > 1">
                      <v-btn text style="min-width: 0px;" class="px-3" @click="removeInsurance(iIndex)"><v-icon>mdi-close</v-icon></v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="text-center mt-4">
                  <v-btn small color="primary" outlined @click="addInsurance"><v-icon small>mdi-plus</v-icon> Add Insurance</v-btn>
                </v-col>
              </v-row>
              <v-row class="my-8 justify-center">
                <v-btn small text color="primary" @click="goBack">Back</v-btn>
                <v-btn small color="primary" class="ml-2" :disabled="!canContinue" @click="nextStep">Continue</v-btn>
              </v-row>
            </v-container>
          </v-stepper-content>


          <v-stepper-step
            :complete="step > 7"
            step="7"
          >
            <span>
              <span :class="{'caption grey--text':step > 7}">Liquid Assets</span>
              <div v-if="step > 7"><b>{{savings.filter(a => a.current_value > 0).length + (savings.filter(a => a.current_value > 0).length == 1 ? ' Account' : ' Accounts')}}</b></div>
            </span>
          </v-stepper-step>
          <div v-if="step == 7">
            <iframe :src="video_object[this.step]" width="100%" height="290" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
          </div>
          <v-stepper-content step="7">
            <div class="title text-center">Include all liquid assets</div>
            <v-container fluid>
              <v-row>
                <v-col
                  cols="12"
                  v-for="(sAccount, sIndex) in savings"
                  :key="'savings-account-' + sIndex"
                  class="py-3"
                >
                  <v-row class="align-center justify-center">
                    <v-col cols="2" class="py-0">
                      <v-select
                        v-model="sAccount.owner"
                        :items="ownerSelections"
                        hide-details
                        outlined
                        dense
                        placeholder="Choose..."
                        label="Owner"
                        clearable
                      />
                    </v-col>
                    <v-col class="py-0" v-if="sAccount.owner" style="width: 240px; max-width: 240px; min-width: 240px;">
                      <v-select
                        v-model="sAccount.type"
                        :items="savingsSelections"
                        hide-details
                        outlined
                        dense
                        placeholder="Choose..."
                        label="Type"
                        clearable
                      />
                    </v-col>
                    <v-col class="py-0" v-if="sAccount.owner && sAccount.type" style="width: 160px; max-width: 160px; min-width: 160px;">
                      <v-text-field
                        v-model="sAccount.current_value"
                        outlined
                        dense
                        hide-details
                        label="Current Value"
                      />
                    </v-col>
                    <v-col cols="2" class="py-0" v-if="sAccount.owner && sAccount.type && sAccount.type == 'savings'">
                      <v-text-field
                        v-model="sAccount.monthly_contribution"
                        outlined
                        dense
                        hide-details
                        label="Monthly Contribution"
                      />
                    </v-col>
                    <v-spacer v-if="savings.length > 1" />
                    <v-col class="py-0 flex-grow-0 flex-shrink-1" v-if="savings.length > 1">
                      <v-btn text style="min-width: 0px;" class="px-3" @click="removeSavings(sIndex)"><v-icon>mdi-close</v-icon></v-btn>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" class="text-center mt-4">
                  <v-btn small color="primary" @click="addSavings" outlined><v-icon small>mdi-plus</v-icon> Add Savings Account</v-btn>
                </v-col>
              </v-row>
              <v-row class="my-8 justify-center">
                <v-btn small text color="primary" @click="goBack">Back</v-btn>
                <v-btn small color="primary" class="ml-2" :disabled="!canContinue" @click="nextStep">Continue</v-btn>
              </v-row>
            </v-container>
          </v-stepper-content>


          <v-stepper-step
            :complete="step > 8"
            step="8"
          >
            <span>
              <span :class="{'caption grey--text':step > 8}">Retirement Accounts</span>
              <div v-if="step > 8"><b>{{retirements.filter(a => a.current_value > 0).length + (retirements.filter(a => a.current_value > 0).length == 1 ? ' Account' : ' Accounts')}}</b></div>
            </span>
          </v-stepper-step>
          <div v-if="step == 8">
            <iframe :src="video_object[this.step]" width="100%" height="290" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
          </div>
          <v-stepper-content step="8">
            <div class="title text-center">Include all retirement accounts</div>
            <v-container fluid>
              <v-row>
                <v-col
                  cols="12"
                  v-for="(rAccount, rIndex) in retirements"
                  :key="'retirement-debt-' + rIndex"
                  class="py-3"
                >
                  <v-row class="align-center justify-center">
                    <v-col cols="2" class="py-0">
                      <v-select
                        v-model="rAccount.owner"
                        :items="ownerSelections"
                        hide-details
                        outlined
                        dense
                        placeholder="Choose..."
                        label="Owner"
                        clearable
                      />
                    </v-col>
                    <v-col class="py-0" v-if="rAccount.owner" style="width: 240px; max-width: 240px; min-width: 240px;">
                      <v-select
                        v-model="rAccount.type"
                        :items="retirementSelections"
                        hide-details
                        outlined
                        dense
                        placeholder="Choose..."
                        label="Type"
                        clearable
                      />
                    </v-col>
                    <v-col class="py-0" v-if="rAccount.owner && rAccount.type" style="width: 160px; max-width: 160px; min-width: 160px;">
                      <v-text-field
                        v-model="rAccount.current_value"
                        outlined
                        dense
                        hide-details
                        label="Current Value"
                      />
                    </v-col>
                    <v-col cols="2" class="py-0" v-if="rAccount.owner && rAccount.type && rAccount.type != 'old401k'">
                      <v-text-field
                        v-model="rAccount.monthly_contribution"
                        outlined
                        dense
                        hide-details
                        label="Monthly Contribution"
                      />
                    </v-col>
                    <v-col cols="2" class="py-0" v-if="rAccount.owner && rAccount.type == '401k'">
                      <v-text-field
                        outlined
                        v-model="rAccount.employer_matchback_amount"
                        label="Employer Contribution"
                        dense
                        hide-details
                      />
                    </v-col>
                    <v-spacer v-if="retirements.length > 1 && (rAccount.type != '401k' || !rAccount.employer_matchback)" />
                    <v-col class="py-0 flex-grow-0 flex-shrink-1" v-if="retirements.length > 1">
                      <v-btn text style="min-width: 0px;" class="px-3" @click="removeRetirement(rIndex)"><v-icon>mdi-close</v-icon></v-btn>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" class="text-center mt-4">
                  <v-btn small color="primary" @click="addRetirement" outlined><v-icon small>mdi-plus</v-icon> Add Retirement Account</v-btn>
                </v-col>
              </v-row>
              <v-row class="my-8 justify-center">
                <v-btn small text color="primary" @click="goBack">Back</v-btn>
                <v-btn small color="primary" class="ml-2" :disabled="!canContinue" @click="nextStep">Continue</v-btn>
              </v-row>
            </v-container>
          </v-stepper-content>


          <v-stepper-step
            :complete="step > 9"
            step="9"
          >
            <span>
              <span :class="{'caption grey--text':step > 9}">What's Next</span>
              <div v-if="step > 9"><b></b></div>
            </span>
          </v-stepper-step>
          <div v-if="step == 9">
            <iframe :src="video_object[this.step]" width="100%" height="290" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
          </div>
          <v-stepper-content step="9">
            <div class="title text-center">Answer the following questions</div>
            <v-container fluid>
              <v-row class="flex-nowrap">
                <v-col>
                  <ol>
                    <li value="1">Are you anticipating any major lifestyle changes?<br>(ie., marriage, divorce, retirement, moving etc.)
                    </li>
                  </ol>
                </v-col>
                <v-col class="text-no-wrap flex-shrink-1 flex-grow-0" style="min-width: 300px;">
                  <v-radio-group row v-model="lifestyleChanges" dense hide-details class="mt-0">
                    <v-radio
                      label="Yes"
                      value="yes"
                    ></v-radio>
                    <v-radio
                      label="No"
                      value="no"
                    ></v-radio>
                    <v-radio
                      label="Uncertain"
                      value="uncertain"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row v-if="lifestyleChanges == 'yes'">
                <v-col cols="12" class="pt-0 pl-9">
                  <v-textarea
                    v-model="lifestyleChangeReason"
                    outlined
                    label="What changes are you expecting?"
                    hide-details
                  />
                </v-col>
              </v-row>
              <v-row class="flex-nowrap align-center">
                <v-col class="text-no-wrap">
                  <ol>
                    <li value="2">Are you happy with your current cash flow?
                    </li>
                  </ol>
                </v-col>
                <v-col class="text-no-wrap flex-shrink-1 flex-grow-0" style="min-width: 300px;">
                  <v-radio-group row v-model="happyCurrentCashflow" dense hide-details class="mt-0" >
                    <v-radio
                      label="Yes"
                      value="yes"
                    ></v-radio>
                    <v-radio
                      label="No"
                      value="no"
                    ></v-radio>
                    <v-radio
                      label="Uncertain"
                      value="uncertain"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row v-if="happyCurrentCashflow == 'no'">
                <v-col cols="12" class="pt-0 pl-9">
                  <v-textarea
                    v-model="whyNotHappy"
                    outlined
                    label="Why not?"
                    hide-details
                  />
                </v-col>
              </v-row>
              <v-row class="flex-nowrap align-center">
                <v-col class="text-no-wrap">
                  <ol>
                    <li value="3">
                      Do you anticipate any significant changes in your cash flow?
                    </li>
                  </ol>
                </v-col>
                <v-col class="text-no-wrap flex-shrink-1 flex-grow-0" style="min-width: 300px;">
                  <v-radio-group row v-model="anticipateCashflowChanges" dense hide-details class="mt-0">
                    <v-radio
                      label="Yes"
                      value="yes"
                    ></v-radio>
                    <v-radio
                      label="No"
                      value="no"
                    ></v-radio>
                    <v-radio
                      label="Uncertain"
                      value="uncertain"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row v-if="anticipateCashflowChanges == 'yes'">
                <v-col cols="12" class="pt-0 pl-9">
                  <v-textarea
                    v-model="cashflowChanges"
                    outlined
                    label="What changes are you expecting?"
                    hide-details
                  />
                </v-col>
              </v-row>
              <v-row class="flex-nowrap align-center">
                <v-col class="text-no-wrap">
                  <ol>
                    <li value="4">
                      Do you anticipate any major expenditures in the near future?
                    </li>
                  </ol>
                </v-col>
                <v-col class="text-no-wrap flex-shrink-1 flex-grow-0" style="min-width: 300px;">
                  <v-radio-group row v-model="anticipateMajorExpenditures" dense hide-details class="mt-0">
                    <v-radio
                      label="Yes"
                      value="yes"
                    ></v-radio>
                    <v-radio
                      label="No"
                      value="no"
                    ></v-radio>
                    <v-radio
                      label="Uncertain"
                      value="uncertain"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row v-if="anticipateMajorExpenditures == 'yes'">
                <v-col cols="12" class="pt-0 pl-9">
                  <v-textarea
                    v-model="majorExpenditure"
                    outlined
                    label="What expenditures?"
                    hide-details
                  />
                </v-col>
              </v-row>
              <v-row class="my-8 justify-center">
                <v-btn small text color="primary" @click="goBack" :disabled="saving">Back</v-btn>
                <v-btn small color="primary" class="ml-2" :disabled="!canContinue" @click="nextStep" :loading="saving">Save</v-btn>
              </v-row>
            </v-container>
          </v-stepper-content>

          <v-stepper-content step="10">
            <v-container fluid>
              <v-row>
                <v-col class="text-center">
                  <v-btn text color="primary" loading>Save</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>

        </v-stepper>

      </v-col>
    </v-row>
  </div>
</template>

<script>

import DebtCard from '@/views/households/liabilities/Card'
import DebtWizard from '@/views/households/liabilities/DebtWizard'
import UserSearchField from '@/components/UserSearchFieldClientEdit'

export default {
  name: 'HouseholdOnboarding',
  props: {
    household: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  components: {
    DebtCard,
    DebtWizard,
    UserSearchField
  },
  data () {
    return {
      step: 1,
      saving: false,
      spouse: null,
      mainIncomes: [],
      incomes: [],
      insurances: [],
      retirements: [],
      savings: [],
      desiredOutcomes: [],

      userHasSavings: false,
      userSavingsCumulative: null,
      userSavingsContribution: null,
      userHasCds: false,
      userCdsCumulative: null,

      spouseHasSavings: false,
      spouseSavingsCumulative: null,
      spouseSavingsContribution: null,
      spouseHasCds: false,
      spouseCdsCumulative: null,

      lifestyleChanges: null,
      lifestyleChangeReason: null,
      happyCurrentCashflow: null,
      whyNotHappy: null,
      anticipateCashflowChanges: null,
      cashflowChanges: null,
      anticipateMajorExpenditures: null,
      majorExpenditure: null,

      expansions: 'user,spouse,user.agent,plans',
      video_object : {
        1: 'https://player.vimeo.com/video/816684540?h=3ff980956e',
        2: 'https://player.vimeo.com/video/816684232?h=a188c84a4f',
        3: 'https://player.vimeo.com/video/816684295?h=1854f5af15',
        4: 'https://player.vimeo.com/video/816684382?h=58b53e8ab7',
        5: 'https://player.vimeo.com/video/816684627?h=46df853dd3',
        6: 'https://player.vimeo.com/video/816684212?h=5fc4587104',
        7: 'https://player.vimeo.com/video/816684261?h=7e7c7aed17',
        8: 'https://player.vimeo.com/video/816684477?h=905207d1e1',
        9: 'https://player.vimeo.com/video/816684817?h=cdc116a1f4',
      },
      form_step : null,
      spouse_full_name:null,
    }
  },
  mounted() {
    this.reset()
    this.spouse_full_name = this.spouse['full_name']
    this.getFormStep()

    console.log(this.ownerSelections)
  },
  watch: {
  },
  computed: {
    canContinue() {
      return this.stepComplete(this.step)
    },
    debtsSorted() {
      let debts = JSON.parse(JSON.stringify(this.household.debts))
      debts.sort((a,b) => parseInt(b.balance) - parseInt(a.balance))
      return debts
    },
    namePlural() {
      if(this.household.user.first_name[ this.household.user.first_name.length - 1 ] == 's') return this.household.user.first_name + '\''
      return this.household.user.first_name + '\'s'
    },
    incomeSum() {
      let total = 0
      this.incomes.forEach(i => {
        if(i.amount) {
          let numb = i.amount.replace(/[^0-9.]/,'')
          if(numb) total += Math.round(parseFloat(numb))
        }
      })
      return total
    },
    mainIncomeSum() {
      let total = 0
      this.mainIncomes.forEach(i => {
        if(i.amount) {
          let numb = i.amount.replace(/[^0-9.]/,'')
          if(numb) total += Math.round(parseFloat(numb))
        }
      })
      return total
    },
    totalDebts() {
      let total = 0
      if (this.household.debts){
        this.household.debts.forEach(d => {
          total += Math.round(parseFloat(d.balance))
        })
      }
      return total
    },
    ownerSelections() {
      console.log(this.spouse)
      let arr = []
      arr.push({text: this.household.user.full_name, value: 'user'});
      if(this.spouse && this.spouse.full_name){
        console.log(this.spouse.full_name)
        arr.push({text: this.spouse.full_name, value: 'spouse'});
      }
      return arr
    },
    retirementSelections() {
      return [
        {
          text: 'Active 401(k)',
          value: '401k'
        },
        {
          text: 'Old 401(k)',
          value: 'old401k'
        },
        {
          text: 'IRA',
          value: 'ira'
        },
        {
          text: 'Roth IRA',
          value: 'roth'
        }
      ]
    },
    savingsSelections() {
      return [
        {
          text: 'Savings Account',
          value: 'savings'
        },
        {
          text: 'C.D.',
          value: 'cd'
        }
      ]
    }
  },
  methods: {
    reset() {
      let intake                              =  this.household.intake

      this.mainIncomes                        = intake.mainIncomes || []
      this.incomes                            = intake.incomes || []
      this.insurances                         = intake.insurances || []
      this.retirements                        = intake.retirements || []
      this.savings                            = intake.savings || []
      this.spouse                             = this.household.spouse ?? {}
      this.lifestyleChanges                   = intake.lifestyleChanges ?? null
      this.lifestyleChangeReason              = intake.lifestyleChangeReason ?? null
      this.happyCurrentCashflow               = intake.happyCurrentCashflow ?? null
      this.whyNotHappy                        = intake.whyNotHappy ?? null
      this.anticipateCashflowChanges          = intake.anticipateCashflowChanges ?? null
      this.cashflowChanges                    = intake.cashflowChanges ?? null
      this.anticipateMajorExpenditures        = intake.anticipateMajorExpenditures ?? null
      this.majorExpenditure                   = intake.majorExpenditure ?? null
      this.desiredOutcomes                    = intake.desiredOutcomes || []

      if(!this.mainIncomes.length) this.addMainIncome()
      if(!this.incomes.length) this.addIncome()
      if(!this.insurances.length) this.addInsurance()
      if(!this.retirements.length) this.addRetirement()
      if(!this.savings.length) this.addSavings()
      if(!this.desiredOutcomes.length) this.addDesiredOutcomes()
      this.step = (Math.round(parseFloat(this.household.intake_step) * 10) / 10 ?? 1)
    },
    addMainIncome() {
      this.mainIncomes.push({
        name: null,
        amount: null,
        increase: null
      })
    },
    removeMainIncome(index) {
      this.mainIncomes.splice(index, 1)
    },
    addIncome() {
      this.incomes.push({
        name: null,
        amount: null,
        increase: null,
        until: null
      })
    },
    removeIncome(index) {
      this.incomes.splice(index, 1)
    },
    addRetirement() {
      this.retirements.push({
        owner: null,
        type: null,
        current_value: null,
        monthly_contribution: null,
        employer_matchback_amount: null
      })
    },
    removeRetirement(index) {
      this.retirements.splice(index, 1)
    },
    addInsurance() {
      this.insurances.push({
        owner: null,
        type: null,
        company: null,
        death_benefit: null,
        monthly_premium: null,
        term_left: null,
        cash_value: null
      })
    },
    removeInsurance(index) {
      this.insurances.splice(index, 1)
    },
    addSavings () {
      this.savings.push({
        owner: null,
        type: null,
        current_value: null,
        monthly_contribution: null
      })
    },
    removeSavings (index) {
      this.savings.splice(index, 1)
    },
    addDesiredOutcomes () {
      if(this.desiredOutcomes.length < 5) this.desiredOutcomes.push('')
    },
    removeDesiredOutcome (index) {
      this.desiredOutcomes.splice(index, 1)
    },
    updateSavedDebt (debt) {
      this.$emit('on-debt-updated', debt)
    },
    formatDate (date) {
      if (!date) return null

      const [year, month] = date.split('-')
      return `${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      let [month, year, year2] = date.split('/')
      if(year2) year = year2
      return `${year}-${month.padStart(2, '0')}`
    },
    goBack() {
      this.step--
    },
    nextStep() {
      if(!this.canContinue) return
      this.step++
      this.saveIntake()
    },
    getFormStep(){
      this.form_step = true;
    },
    stepComplete(step) {
      if(step == 1) return true
      if(step == 2) return true
      if(step == 3) return true
      if(step == 4) return true
      if(step == 5) return true
      if(step == 6) return true
      if(step == 7) return true
      if(step == 8) return true
      if(step == 9) return true
      if(step == 10) return true
      return false
    },
    toggleDebt(debt_id) {
      if(this.selectedDebts.indexOf(debt_id) >= 0) {
        this.selectedDebts = this.selectedDebts.filter(v => v !== debt_id)
      } else {
        this.selectedDebts.push(debt_id)
      }
    },
    toggleAll() {
      let arr = []
      this.household.debts.forEach(d => {
        arr.push(d.id)
      })
      this.selectedDebts = arr
    },
    allowedDates(val) {
      return this.$moment().format('YYYY-MM') < val
    },
    newSpouseId(data){
      if(data && data.spouse){
        this.household.spouse_id = data.spouse.id;
        this.spouse = data.spouse;
        this.spouse_full_name = data.spouse.full_name
        if(data.spouse.full_name){
          this.spouse_full_name = data.spouse.full_name
        }
      }
    },
    saveIntake() {
      let token = [];
      if(this.step == 10) {
        this.$swal.fire({
          title: 'Thank you for this information.  An agent will be in contact with you shortly.',
          icon: 'success',
          showCancelButton: false,
          showConfirmButton: true
        })
        this.saving = true
        token = this.$route.params.token;
      }


      this.retirements.forEach((r,i) => {
        if(!r.id) this.retirements[i].id = Date.now() + '-' + Math.floor(Math.random() * 100000000)
      })
      this.insurances.forEach((r,i) => {
        if(!r.id) this.insurances[i].id = Date.now() + '-' + Math.floor(Math.random() * 100000000)
      })
      this.savings.forEach((r,i) => {
        if(!r.id) this.savings[i].id = Date.now() + '-' + Math.floor(Math.random() * 100000000)
      })

      let data = {
        token:token,
        household_id: this.household.id,
        spouse_id: (this.spouse ? this.spouse.id : null),
        intake_data: {
          desiredOutcomes: this.desiredOutcomes,
          mainIncomes: this.mainIncomes,
          incomes: this.incomes,
          retirements: this.retirements,
          insurances: this.insurances,
          savings: this.savings,
          lifestyleChanges: this.lifestyleChanges,
          lifestyleChangeReason: this.lifestyleChangeReason,
          happyCurrentCashflow: this.happyCurrentCashflow,
          whyNotHappy: this.whyNotHappy,
          anticipateCashflowChanges: this.anticipateCashflowChanges,
          cashflowChanges: this.cashflowChanges,
          anticipateMajorExpenditures: this.anticipateMajorExpenditures,
          majorExpenditure: this.majorExpenditure
        },
        intake_step: (this.step == 10 ? 0 : this.step)
      }

      this.$http.post('household-customer-data/update-household', data)
        .then(response => {
          // console.log(response)
          // this.$emit('on-intake-updated', response.data)
          if(!response.data.intake_step) {
            this.$router.replace({name: 'households-prd-freedom-accelerator', params: {household_id: this.$route.params.household_id }})
          }
        })
        .catch(err => {
          console.log(err)
          this.$swal.fire('Error', 'There was an error processing your information', 'error')
        })
        .finally(() => {
          this.saving = false
        })
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
